import { DeleteVariable } from 'api/variables-endpoint';
import ConfirmButton from 'components/ConfirmButton';
import useAuthorizationChecks from 'hooks/useOperationAuthorizationChecks';
import { getLinkToCreateVariable } from 'navigator/links';
import { useNavigate } from 'react-router-dom';
import { useVariablesContext } from 'stores/variables-context';
import { Variable } from 'types/variable';
import { UserOperations } from 'types/user';

interface DeleteVariableButtonProps {
  variable: Variable;
  className?: string;
  onDeleteFail: (message: string) => void;
}

function DeleteVariableButton({ variable, className, onDeleteFail }: DeleteVariableButtonProps): JSX.Element {
  const variablesContext = useVariablesContext();
  const navigate = useNavigate();
  const canDeleteVariable = useAuthorizationChecks([UserOperations.VARIABLE_DELETE]);

  if (!canDeleteVariable) {
    return <></>;
  }

  const handleClick = async () => {
    const response = await DeleteVariable(variable);
    if (response.success) {
      variablesContext.fetchData();
      navigate(getLinkToCreateVariable());
    } else {
      onDeleteFail(response.message || '');
    }
  };

  return <ConfirmButton label='Delete Variable' onClick={handleClick} className={className} />;
}

DeleteVariableButton.defaultProps = {
  className: undefined,
};

export default DeleteVariableButton;
